import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import Vuesax from 'vuesax'
import Notifications from 'vue-notification'
import VueProgressBar from 'vue-progressbar'
import LoadScript from 'vue-plugin-load-script'
import VueFormWizard from 'vue-form-wizard'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faTasks, faCalendarPlus, faPlusCircle, faCogs, faTimesCircle, faEdit, faUserCog, faTrashAlt, faMarker, faPlay, faUsers, faClipboardList, faCashRegister, faInfoCircle, faSignOutAlt, faBars, faEllipsisV, faFileDownload, faFileUpload, faSearchLocation , faPlus, faTimes, faCheck, faExclamationTriangle, faSync, faFileArchive, faEye, faMapMarkedAlt, faMapMarkerAlt, faUser, faKey, faUserTie, faArrowLeft, faCog, faFilePdf, faChevronDown, faFileImport, faFileAlt, faFileExcel, faFileExport, faCheckSquare, faRedoAlt, faRedo, faShareSquare, faUserPlus, faUserTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faTasks, faCalendarPlus, faPlusCircle, faCogs, faTimesCircle, faEdit, faUserCog, faTrashAlt, faMarker, faPlay, faUsers, faClipboardList, faCashRegister, faInfoCircle, faSignOutAlt, faBars, faEllipsisV, faFileDownload, faFileUpload, faSearchLocation, faPlus, faTimes, faCheck, faExclamationTriangle, faSync, faFileArchive, faEye, faMapMarkedAlt, faMapMarkerAlt, faUser, faKey, faUserTie, faArrowLeft, faCog, faFilePdf, faChevronDown, faFileImport, faFileAlt, faFileExcel, faFileExport, faCheckSquare, faRedoAlt, faRedo, faShareSquare, faUserPlus, faUserTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(LoadScript)

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'material-icons/iconfont/material-icons.css'
import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax)

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.config.productionTip = false

import store from './store'

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

/* CONFIG */
import {globalConf} from './config.global'

Vue.prototype.$hostlink = globalConf.hostlink
Vue.prototype.$impersona = false

/*VUE-RESONCE INTERCEPTOR*/
Vue.http.interceptors.push(function(request) {
  if(request.url.indexOf("http://") == -1)
    request.url = globalConf.hostlink+request.url

  Vue.prototype.$Progress.start()
  return function(response) {
    Vue.prototype.$Progress.finish()
    if(response.status == 500 && response.bodyText == "Error!"){
      location.reload()
    }
  }
})

//Vue.config.silent = true